import { sportingAPI } from 'services/sporting/api';

export const getAllCompetitionsRequestsCount = async (): Promise<number> => {
  const competitionIds = await sportingAPI.service.getParticipationsCountForNearCompetitions();

  return competitionIds.length;
};
